import { render, staticRenderFns } from "./TempConfigBaseSettingsItemPerson.vue?vue&type=template&id=4cdf0dd8&scoped=true"
import script from "./TempConfigBaseSettingsItemPerson.vue?vue&type=script&lang=js"
export * from "./TempConfigBaseSettingsItemPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdf0dd8",
  null
  
)

export default component.exports